import { z } from 'zod';

export const UserSegmentSchema = z.object({
  days_since_last_order: z.number().optional(),
  total_orders_paid: z.number().optional(),
  total_money_disbursed: z.number().optional(),
});

export const BaseEventSchema = z.object({
  meki_session_id: z.string().optional(), // TODO: Check this
  timestamp: z.string(),
  screen_instance_id: z.string(),
  user_id: z.number().optional(),
  user_segmentation_data: UserSegmentSchema.optional(),
});
